<template>
	<div>
		<div class="input">
			<input
				type="text"
        ref="ipt"
				:placeholder="placeholder"
				v-model="inputValue"
				v-bind="$attrs"
				@focus="focusEvent"
				@blur="blurEvnet"
				@input="triggerInput"
				:class="[focus?'focuse': '', errMsg?'has_error':'']"
			/>
			<div class="span_title">{{title}}</div>
			<div class="code">
				<span class="tip" :style="inputValue.length == 11 ? 'color: #009688': ''" v-if="isCanGetCode" @click='getCodeEvent'>获取验证码</span>
				<span class="tip active" v-else>（{{time}}）秒</span>
			</div>
		</div>
		<span class='error' v-show='errMsg'>{{errMsg}}</span>
	</div>
</template>

<script>
export default {
  data() {
    return {
			focus: false,
			isCanGetCode: true,
      time: 60
    };
  },
  props: {
    value: {},
    title: {
      type: String,
      default: "手机号"
    },
    placeholder: {
      type: String,
      default: "请输入手机号"
		},
		errMsg: {
			type: String,
			default: ''
		}
	},
	
	computed: {
		inputValue: { // 数据双向绑定检测
			get() {
				return this.value
			},

			set(value) {
				this.$emit('input', value)
			}
		}

	},

  methods: {
    onFocus() {
      this.focus = true
    },

    focusEvent() {
			// 聚焦检测
			this.focus = true
			this.$emit('focus')
    },

    // 调用 手动控制输入框聚焦
    onFocusHandle() {
      this.$refs.ipt.focus()
    },

    blurEvnet() {
			// 失焦检测
			this.focus = false
			this.$emit('blur')
		},
		
		triggerInput() {
			// 输入校验
			this.$emit('inputTest')
		},

		getCodeEvent() {
			if (this.inputValue.length !==11) return 
      this.isCanGetCode = false
      this.$emit('getLoginCode')
      this.$emit('getRegisterCode')
			this.timeId = setInterval(() => {
				this.time--
				if (this.time === 0) {
					clearInterval(this.timeId)
					this.time = 60
					this.isCanGetCode = true
				}
			}, 1000)
		}
  }
}
</script>

<style lang='scss' scoped>
.input {
  position: relative;
}
input {
  width: 100%;
  height: 50px;
  // line-height: 50px;
  outline-style: none;
  font-size: 14px;
  color: #333;
  padding: 15px 100px 15px 60px;
  background: #ffffff;
  text-align: right;
  border: 2px solid rgba(239, 242, 244, 1);
  border-radius: 5px;
}

.span_title {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 14px;
  color: #666;
}

.code {
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
  position: absolute;
  right: 0;
  top: 0;

  .tip {
    display: inline-block;
    width: 100%;
    min-width: 92px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    padding: 0 10px;
    color: rgba(0, 150, 136, 0.3);
    border-left: 2px solid #eff2f4;
    font-size: 14px;
    font-weight: bold;
  }

  .active {
    color: #009688;
  }
}

.focuse {
  border: 2px solid #009688 !important;
}

.error {
	display: inline-block;
  color: #EE5B5B;
  font-size: 12px;
  font-weight: bolder;
  padding-left: 5px;
  margin-top: 10px;
}

.has_error {
	border: 2px solid #EE5B5B!important;
}
</style>